import { IResponse } from "@app/common/types/http";
import { HTTP_DISPENSARY } from "@app/config/axios";
import {
  DetailSupportDispensaryResponse,
  IConsumerOutReportFilters,
  ISupportConsultResponse,
  SupportConsultFilter,
  SupportConsultResponse,
  UpdSupportFile
} from "./types";
import { clearEmptyKeys } from "@app/common/utils/utils";

export async function supportConsultListService(filters: SupportConsultFilter, token: string) {
  const res = await HTTP_DISPENSARY(token).get<IResponse<SupportConsultResponse[]>>(
    "/dispensarySupports/",
    { params: filters }
  );
  return res.data;
}

export async function consumerOutReportsService(filters: IConsumerOutReportFilters, token: string) {
  const sanetizedFilters = clearEmptyKeys(filters);

  const res = await HTTP_DISPENSARY(token).get<IResponse<ISupportConsultResponse[]>>(
    "/dispensaries/consumption-output-report",
    { params: sanetizedFilters }
  );
  return res.data;
}

export async function supportDetailDispensaryService(filters: { id: number }, token: string) {
  const res = await HTTP_DISPENSARY(token).get<IResponse<DetailSupportDispensaryResponse>>(
    `/dispensarySupports/detail/${filters.id}`,
    { params: filters }
  );
  return res.data;
}

export async function handleUpdateSupportFileService(payload: UpdSupportFile, token: string) {
  const axiosInstance = HTTP_DISPENSARY(token);
  const response = await axiosInstance.patch<IResponse>(
    `/dispensarySupports/${payload.id}`,
    payload
  );
  return response.data;
}
export async function postCommentSupport(
  payload: { rdsId: number; comment: string },
  token: string
) {
  const axiosInstance = HTTP_DISPENSARY(token);
  const response = await axiosInstance.post<IResponse>("/commentsDispensarySupport/", payload);
  return response.data;
}

export async function updateSupportFileService(payload: UpdSupportFile, token: string) {
  const axiosInstance = HTTP_DISPENSARY(token);
  const response = await axiosInstance.put<IResponse>("/dispensarySupports/", payload);
  return response.data;
}

export const downloadSupportConsultExcel = async (filters: SupportConsultFilter, token: string) => {
  const res = await HTTP_DISPENSARY(token).get<IResponse<{ base64: string }>>(
    "/dispensaries/fomag-excel",
    { params: filters }
  );

  return res.data;
};

export const downloadConsumerOutReportsExcel = async (
  filters: IConsumerOutReportFilters,
  token: string
) => {
  const sanetizedFilters = clearEmptyKeys(filters);
  const res = await HTTP_DISPENSARY(token).get<IResponse<{ base64: string }>>(
    "/dispensaries/consumption-output-report/excel",
    { params: sanetizedFilters }
  );

  return res.data;
};
